import { H2, H3 } from '@repo/ui/components/Typography';
import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

import { HORIZONTAL_PADDING_MOBILE } from 'components/utilities/pageStyles';
import { FlexColumn } from 'styles/layouts';

export const Wrapper = styled.div`
  margin: 0 -${HORIZONTAL_PADDING_MOBILE};
  padding: 48px 25px;
  background: ${themeStyle.backgroundBase};

  ${QUERIES.laptopAndUp} {
    padding: 72px 90px;
    border-radius: ${themeStyle.radiusSmall};
  }
`;

export const Title = styled(H3)`
  text-align: center;
  margin-bottom: 48px;

  ${QUERIES.laptopAndUp} {
    margin-bottom: 58px;
    font-size: ${themeStyle.fontSize26};
    line-height: ${themeStyle.fontSize26};
  }
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 24px;
`;

export const Item = styled(FlexColumn)`
  gap: 8px;
  align-items: center;
  text-align: center;
  margin: 0 auto;

  ${QUERIES.laptopAndUp} {
    gap: 12px;
  }
`;

export const Number = styled(H2)`
  font-size: ${themeStyle.fontSize26};
  line-height: ${themeStyle.fontSize26};

  ${QUERIES.laptopAndUp} {
    font-size: ${themeStyle.fontSize36};
    line-height: ${themeStyle.fontSize36};
  }
`;
